import React from 'react'
import MenuItem from './MenuItem'

function MenuSection({menuSection}) {
    const {category, products} = menuSection
    return (
        <div id={"#"+category}> 
            <h1>{category}</h1> 
            {products.map((menuItem) => {
                return <MenuItem menuItem={menuItem}/>
            })} 
        </div>
    )
}

export default MenuSection
